// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { type RendererObject, marked } from 'marked';
import * as React from 'react';
import { Root } from './Markdown';

interface Props {
  readonly source: string;
  readonly 'data-test'?: string;
}
export default function RenderMarkdown({ 'data-test': dataTest, source }: Props) {
  const renderer: RendererObject = {
    link({ href, text, title }): string {
      return `<a href="${href}" ${title ? `title="${title}"` : ''} target="_blank" rel="noopener noreferrer">${text}</a>`;
    },
  };
  marked.use({ renderer });
  // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
  return <Root data-test={dataTest} dangerouslySetInnerHTML={{ __html: marked.parse(source) }} />;
}
